export default __webpack_public_path__ + "static/walkerssk-advisor-9652579_1920-6d7b352834ab8a4b5b862e68b2a36370.jpg";